import { Link } from "react-router-dom";
import { SEO_LOCATIONS, SEO_PAGE_TYPES } from "../data/seoLocations";

function buildSeoPath(pageType, locSlug) {
  return `/${pageType}-in-${locSlug}`;
}

export default function SeoQuickLinks() {
  return (
    <section className="bg-[#F8F5EE] px-4 sm:px-6">
      <div className="mx-auto max-w-6xl">
        <details className="group rounded-3xl border border-[#E6DED1] bg-white/95 shadow-sm overflow-hidden">
          <summary className="cursor-pointer list-none px-5 py-4 sm:px-6 flex items-center justify-between gap-4">
            <div className="text-left">
              <p className="text-xs font-black uppercase tracking-[0.22em] text-[#FF6B35]">
                SEO Pages
              </p>
              <h2 className="text-base sm:text-lg font-black text-[#0D1B2A]">
                Explore all location pages
              </h2>
              <p className="text-xs sm:text-sm text-gray-500">
                Tap once to open 35 local search links for preschool and daycare pages.
              </p>
            </div>
            <span className="inline-flex shrink-0 items-center rounded-full bg-[#FFF0EA] px-4 py-2 text-xs font-bold text-[#FF6B35] transition group-open:bg-[#FF6B35] group-open:text-white">
              Open links
            </span>
          </summary>

          <div className="border-t border-[#EDE9E2] px-4 py-5 sm:px-6">
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
              {SEO_LOCATIONS.map((location) => (
                <div key={location.slug} className="rounded-2xl border border-[#EDE9E2] bg-[#FAF8F3] p-4">
                  <div className="mb-3">
                    <p className="text-sm font-black text-[#0D1B2A]">{location.name}</p>
                    <p className="text-xs text-gray-500">{location.nearby}</p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {SEO_PAGE_TYPES.map((pageType) => (
                      <Link
                        key={`${pageType.type}-${location.slug}`}
                        to={buildSeoPath(pageType.type, location.slug)}
                        className="inline-flex items-center rounded-full border border-[#FF6B35]/20 bg-white px-3 py-1.5 text-[11px] font-semibold text-[#0D1B2A] transition hover:border-[#FF6B35] hover:text-[#FF6B35]"
                      >
                        {pageType.label}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </details>
      </div>
    </section>
  );
}
